import React from "react";
// material-ui components
import {withStyles} from "@material-ui/core/styles";
import appointmentCardStyle from "../assets/jss/material-kit-react/components/appointmentCardStyle";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "./CustomInput/CustomInput";
import {TextField} from "@material-ui/core";

class AppointmentCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: {value: '', valid: false},
      title: {value: '', valid: false},
      location: {value: '', valid: true},
      description: {value: '', valid: false},
    }
    this.handleInputEmail = this.handleInputEmail.bind(this)
    this.handleInputTitle = this.handleInputTitle.bind(this)
    this.handleInputLocation = this.handleInputLocation.bind(this)
  }

  componentDidMount() {
    this.initAppointmentInfo()
  }

  initAppointmentInfo = () => {
    const props = this.props.initAppointmentInfo
    if (props === undefined) {
      return
    }
    if (Object.keys(props).length > 0 && props.constructor === Object) {
      this.setState({
        email: {value: props.email.value, valid: props.email.valid},
        title: {value: props.title.value, valid: props.title.valid},
        description: {value: props.description.value, valid: props.description.valid},
        location: {value: props.location.value, valid: props.location.valid}
      })
    }
  }
  returnAppointmentInfo = () => {
    this.props.appointmentInfo(
      {
        email: {value: this.state.email.value, valid: this.state.email.valid},
        title: {value: this.state.title.value, valid: this.state.title.valid},
        location: {value: this.state.location.value, valid: this.state.location.valid},
        description: {value: this.state.description.value, valid: this.state.email.valid}
      }
    )
  }

  checkInput(str) {return str !== '' && str !== undefined
  }

  async handleInputTitle(events) {
    const val = events.target.value
    await this.setState({title: {value: val, valid: this.checkInput(val)}})
    await this.returnAppointmentInfo()
  }

  async handleInputEmail(events) {
    const val = events.target.value
    await this.setState({email: {value: val, valid: this.checkEmail(val)}});
    await this.returnAppointmentInfo()
  }

  checkEmail = (evalString) => {
    // copied off stackoverflow. this regex looks ridiculous.
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const error = re.test(evalString.toLowerCase());
    return error
  }

  async handleInputLocation(events) {
    const val = events.target.value
    await this.setState({location: {value: val, valid: true}})
    // await this.setState({location: {value: val, valid: this.checkInput(val)}})
    await this.returnAppointmentInfo()
  }

  handleInputDescription = (events) => {
    const val = events.target.value
    this.setState({description: {value: val, valid: this.checkInput(val)}})
    this.returnAppointmentInfo()
  }


  render() {
    const {classes} = this.props;

    return (
      <div className={classes.cardContainer}>
        <Card>
          <CardBody>
            <CustomInput
              labelText="E-Mail Address"
              id="email"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: this.state.email.value,
                onChange: this.handleInputEmail,
                error: !this.state.email.valid,
                type: 'email'
              }}
              labelProps={{required: true}}
            />
            <CustomInput
              className={classes.inputLabel}
              labelText="Title"
              id="title"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: this.state.title.value,
                onChange: this.handleInputTitle,

              }}
              labelProps={{required: true}}
            />

            <CustomInput
              labelText="Video call URL - auto-generated if not provided."
              id="videoCall"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: this.state.location.value,
                onChange: this.handleInputLocation
              }}
              labelProps={{required: false}}
            />
            <TextField
              label="description"
              inputProps={{
                maxLength: 1000
              }}
              size={"small"}
              fullWidth={true}
              value={this.state.description.value}
              helperText={`${this.state.description.value.length}/${1000}`}
              onChange={this.handleInputDescription}
              margin="dense"
              variant="outlined"
              multiline={true}
              rows={10}
            />

          </CardBody>
        </Card>
      </div>
    )
  }

}

export default withStyles(appointmentCardStyle)(AppointmentCard)
